import { store } from 'store';
import { LOGOUT, SNACKBAR_OPEN } from 'store/actions';

/* eslint-disable no-underscore-dangle */
const handleAxiosError = (error) => {
    if (error.response) {
        const { status } = error.response;

        if (error.response.data.message?.Status === 'Failed' || error.response.data.message?.Status === 'FailedRetryable') {
            return error.response.data.message?.Narration || error.response.data.message?.TechnicalNarration;
        }

        if (error.response.data.message?.Message) {
            return error.response.data.message.Message;
        }

        const sessionExpired = error.response.data?.session_expired;
        if (sessionExpired === 1 || sessionExpired === '1') {
            // Dispatch a logout action in Redux
            store.dispatch({ type: LOGOUT });
            sessionStorage.clear();
            return 'Your session has expired. Please log in again.';
        }

        if (error.response.data.exc_type === 'ValidationError') {
            if (error.response.data.exception && Array.isArray(error.response.data.exception)) {
                let message = error.response.data.exception.split('frappe.exceptions.ValidationError:');
                return message[1].trim();
            }

            if (Array.isArray(error.response.data.message) && error.response.data.message.length > 1) {
                return error.response.data.message[1].trim();
            }
            
            return 'Validation Error';
        }

        if (error.response.data.exc_type === 'PermissionError') {
            const message = error.response.data.exception.split('frappe.exceptions.PermissionError:');
            // Dispatch a logout action in Redux
            store.dispatch({ type: LOGOUT });
            sessionStorage.clear();
            return 'PermissionError: Your session has expired. Please log in again.';
        }
        if (error.response.data.exc_type === 'CSRFTokenError') {
            return 'CSRFTokenError: Invalid Request';
        }
        if (error.response.data.exception === 'frappe.exceptions.AuthenticationError') {
            return error.response.data.message;
        }

        if (error.response.data.message) {
            if (Array.isArray(error.response.data.message)) {
                if (error.response.data.message.length === 2) return error.response.data.message[1];
            }
            return error.response.data.message;
        }

        if (error.response.data.exception) {
            return error.response.data.exception;
        }

        if (error.response.data._error_message) {
            return error.response.data._error_message;
        }

        const err = error.toJSON();
        return err.message;
    }
    if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        return error.toString();
    }
    // Something happened in setting up the request that triggered an Error
    return `Error : ${error.message}`;
};

// "exception": "frappe.exceptions.ValidationError: Third Party Error",

export default handleAxiosError;

// const isLoggedIn = store.getState().auth.isLoggedIn;

// if (status === 401 || status === 403) {
//     const isLoggedIn = store.getState().auth.isLoggedIn;
//     if (isLoggedIn) {
//         // Dispatch a logout action in Redux
//         store.dispatch({ type: LOGOUT });
//         sessionStorage.clear();
//         store.dispatch({
//             type: SNACKBAR_OPEN,
//             open: true,
//             message: 'Your session has expired. Please log in again.',
//             variant: 'alert',
//             alertSeverity: 'error',
//             anchorOrigin: {
//                 vertical: 'top',
//                 horizontal: 'right'
//             }
//         });
//     }
// }
